export default __webpack_public_path__ + "11807d8a0741d067a70df57ef02c0dd6.svg";